import React from 'react';
import { Routes, Route } from 'react-router';
import PrivateComponent from '../components/PrivateComponent';
import HistoryView from '../views/HistoryView';
import PreferencesView from '../views/PreferencesView';
import HomeDashboardView from '../views/HomeDashboardView';
import ConsoleView from '../views/ConsoleView';
import UserGuide from '../views/UserGuide';
import CountdownView from '../views/CountdownView';
import AccountView from '../views/AccountView';
import MarketplaceView from '../views/workspace/MarketplaceView';
import DatasetSearchView from '../views/workspace/DatasetSearchView';
import WorkflowCreatorView from '../views/workspace/WorkflowCreatorView';
import WorkflowEditorView from '../views/workspace/WorkflowEditorView';
import DataVisualizationView from '../views/workspace/DataVisualizationView';
import MapVisualizationView from '../views/workspace/MapVisualizationView';
import FileExplorerView from '../views/workspace/FileExplorerView';
import XrVrView from '../views/workspace/XrVrView';

const routes = [
  { path: '/', element: <HomeDashboardView /> },
  { path: '/home', element: <HomeDashboardView /> },
  { path: '/workspace/marketplace', element: <MarketplaceView /> },
  { path: '/workspace/dataset-search', element: <DatasetSearchView /> },
  { path: '/workspace/workflow-creator', element: <WorkflowCreatorView /> },
  { path: '/workspace/workflow-editor', element: <WorkflowEditorView /> },
  { path: '/workspace/data-visualization', element: <DataVisualizationView /> },
  { path: '/workspace/map-visualization', element: <MapVisualizationView /> },
  { path: '/workspace/file-explorer', element: <FileExplorerView /> },
  { path: '/workspace/xr-vr', element: <XrVrView /> },
  { path: '/user-guides', element: <UserGuide /> },
  { path: '/history', element: <HistoryView /> },
  { path: '/console', element: <ConsoleView /> },
  { path: '/account', element: <AccountView /> },
  { path: '/preferences', element: <PreferencesView /> },
  { path: '/countdown', element: <CountdownView /> },
];

function MyRoutes() {
  return (
    <Routes>
      {routes.map(({ path, element }) => (
        <Route key={path} path={path} element={<PrivateComponent>{element}</PrivateComponent>} />
      ))}
    </Routes>
  );
}

export default MyRoutes;
